module.exports = __webpack_public_path__ + "img/calendar-empty-list-light.05a4c717.svg";